module.exports = __webpack_public_path__ + "media/assets/1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/1.svg
// module id = 11
// module chunks = 0